import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-of-service">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-gray-500 mb-8">Last updated: May 31, 2026</p>

        <div className="prose prose-gray max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By using the Jiffys Assistance mobile application and website, you agree to these Terms of Service. If you do not agree, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">2. Services</h2>
            <p className="text-gray-700 leading-relaxed">
              Jiffys Assistance provides a platform connecting customers with roadside assistance providers, mobile mechanics, and delivery drivers. We are a technology platform and do not directly perform vehicle services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">3. User Accounts</h2>
            <ul className="list-disc ml-6 text-gray-700 space-y-2">
              <li>You must be at least 18 years old to create an account.</li>
              <li>You are responsible for maintaining the security of your account credentials.</li>
              <li>Service providers must pass background checks and maintain valid certifications and insurance.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">4. Payments & Cancellations</h2>
            <ul className="list-disc ml-6 text-gray-700 space-y-2">
              <li>Roadside assistance and delivery services require upfront payment.</li>
              <li>Mobile mechanic services are billed after service completion.</li>
              <li>Customers may cancel a request after 45 minutes. A $7 cancellation fee applies if a provider has already been assigned.</li>
              <li>Service providers may decline any job without penalty.</li>
              <li>Tips are optional and 100% go to the service provider.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">5. Service Provider Requirements</h2>
            <ul className="list-disc ml-6 text-gray-700 space-y-2">
              <li>All providers must complete identity verification and background checks.</li>
              <li>Mobile mechanics must maintain valid certifications, training records, and insurance.</li>
              <li>Providers must upload photo proof upon service completion.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">6. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              Jiffys Assistance is a platform connecting users with independent service providers. We are not liable for the quality of services performed by providers. Disputes should be reported within 24 hours of service completion.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">7. Contact</h2>
            <p className="text-gray-700 leading-relaxed">
              Email: support@jiffysassistance.site<br />
              Phone: (260) 218-3536
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
